<template>
  <v-row class="fill-height pb-12 pt-2 mx-1">
    <v-col>
      <v-sheet height="64">
        <!-- header -->
        <v-toolbar
          flat>
          <v-btn outlined class="mr-4" color="grey darken-2" @click="setToday">
            HOY
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="prev">
            <v-icon small>
              mdi-chevron-left
            </v-icon>
          </v-btn>
          <v-btn fab text small color="grey darken-2" @click="next">
            <v-icon small>
              mdi-chevron-right
            </v-icon>
          </v-btn>
          <v-toolbar-title v-if="$refs.calendar">
            {{ $refs.calendar.title }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu bottom right>
            <template v-slot:activator="{ on, attrs }">
              <v-btn outlined color="grey darken-2" v-bind="attrs" v-on="on">
                <span>{{ typeToLabel[type] }}</span>
                <v-icon right>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="type = 'day'">
                <v-list-item-title>Día</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>Semana</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>Mes</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn icon class="ml-2">
            <v-icon @click="openFilter">mdi-filter</v-icon>
          </v-btn>
        </v-toolbar>
      </v-sheet>
      <v-sheet height="600">
        <!-- calendario -->
        <v-calendar
          v-if="render"
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="events"
          :event-color="getEventColor"
          :type="type"
          @click:event="showEvent"
          @click:more="viewDay"
          @click:date="viewDay"
          @change="updateRange"
          event-text-color="white"
        ></v-calendar>
        <!-- Detalle del evento -->
        <v-menu v-model="selectedOpen" :close-on-content-click="false" :activator="selectedElement" offset-x >
          <v-card flat width="400px">
            <v-toolbar style="margin-bottom:-10px;" class="elevation-0">
              <v-icon :color="selectedEvent.color" class="pr-2"> mdi-checkbox-blank</v-icon>
              <v-toolbar-title color="#3c4043">
                {{selectedEvent.name}}
              </v-toolbar-title><!-- #32241c -->
              <v-chip x-small dark class="ml-4" color="primary">{{selectedEvent.activity_type}}</v-chip>
              <v-spacer></v-spacer>
              <v-menu bottom left>
                <template v-slot:activator="{ on, attrs }">
                <v-btn v-show="permissions('editActivities')" icon v-bind="attrs" v-on="on">
                  <v-icon color="#3c4043" small>mdi-dots-vertical</v-icon>
                </v-btn>
                </template>
                <v-list style="font-size:13px;">
                  <v-list-item @click="editItem(selectedEvent.editedItem)">
                    <v-icon small class="mr-2">
                      mdi-pencil
                    </v-icon>
                    Editar
                  </v-list-item>
                  <v-list-item @click="deleteItem(selectedEvent)">
                    <v-icon small class="mr-2">
                      mdi-delete
                    </v-icon>
                    Eliminar
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-btn icon @click="selectedOpen=false">
                <v-icon color="#3c4043" small> mdi-close</v-icon><!-- #32241c -->
              </v-btn>
            </v-toolbar>
            <div class="pt-2 mx-4 mb-0" color="primary">
              <v-icon color="primary" class="mr-2 mb-1">mdi-calendar</v-icon><span style="font-size:15px; color: #1976d1; font-weight: 500;">{{fecha(selectedEvent.start)}}</span>
            </div>
            <div class="pb-1 mx-4 mb-2" color="primary">
              <v-icon color="primary" class="mr-2 mb-1">mdi-clock-outline</v-icon><span style="font-size:15px; color: #1976d1; font-weight: 500;">{{formatAMPM(selectedEvent.start)}}</span>
            </div>
            <v-card-text class="px-6 pt-1" style="color:#3c4043;">
              <div class="htmlcontent my-6 px-4 md:px-0 content" v-html="htmlContent(selectedEvent.description)"></div>
            </v-card-text>
          </v-card>
        </v-menu>
      </v-sheet>
    </v-col>
    <!-- Crear actividad -->
    <v-dialog v-model="createDialog" max-width="900px">
      <template v-slot:activator="{ on, attrs }">
        <v-btn bottom color="primary" dark fab fixed right v-bind="attrs" v-on="on">
            <v-icon color="white">  mdi-plus </v-icon>
        </v-btn> 
      </template>
      <create @closeCreateDialogCalendar="closeCreateDialogCalendar"/>
    </v-dialog>
    <!-- Editar actividad -->
    <v-dialog v-model="editDialog" max-width="900px">
      <edit v-bind:calendar="calendar" @closeDialogEditCalendar="closeDialogEditCalendar"/>
    </v-dialog>
    <!-- Dialogo confirmación -->
    <div class="text-center">
      <v-bottom-sheet  v-model="sheet" inset>
        <v-sheet class="text-center" height="150px">
          <div class="pt-6">
          ¿Seguro que deseas borrar este anuncio?
          </div>
          <v-btn class="mt-4" text color="error" @click="deleteCalendar()">
          Eliminar
          </v-btn>
          <v-btn class="mt-4" text color="grey" @click="cancel()">
          Cancelar
          </v-btn>
        </v-sheet>
      </v-bottom-sheet>
    </div>
    <!-- Filtros -->
    <v-navigation-drawer style="top: 0px; max-height:100vh!important;" right v-model="filters" :clipped="$vuetify.breakpoint.lgAndUp" app>
        <filterActivities @filtersActivities="getActivities"/>
    </v-navigation-drawer>
  </v-row>
</template>
<script>
  import axios from "axios"
  import Filter from "../announcements/filter"
  import Create from "../announcements/create"
  import Edit from "../announcements/edit"
  export default {
    components: {
      'filterActivities':Filter,
      'create':Create,
      'edit':Edit,
    }, 
    data: () => ({
      render:true,
      filters: false,
      focus: '',
      type: 'month',
      typeToLabel: {
        month: 'Mes',
        week: 'Semana',
        day: 'Día',
      },
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      events: [],
      deleteId:'',
      sheet: false,
      calendar:'',
      editDialog: false,
      sheet: false,
      sheet2: false,
      calendar:'',
      editDialog: false,
      createDialog: false,
      newActivityClient:undefined,
      newActivityLead:undefined,
      start:'',
      end:''
    }),
    mounted () {
      this.$refs.calendar.checkChange()
    },
    methods: {
      viewDay ({ date }) {
        this.focus = date
        this.type = 'day'
      },
      getEventColor (event) {
        return event.color
      },
      setToday () {
        this.focus = ''
      },
      prev () {
        this.$refs.calendar.prev()
      },
      next () {
        this.$refs.calendar.next()
      },
      showEvent ({ nativeEvent, event }) {
        const open = () => {
          this.selectedEvent = event
          this.selectedElement = nativeEvent.target
          requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
        }
        if (this.selectedOpen) {
          this.selectedOpen = false
          requestAnimationFrame(() => requestAnimationFrame(() => open()))
        } else {
          open()
        }
        nativeEvent.stopPropagation()
      },
      updateRange ({ start, end }) {
        this.start = start.date || new Date().toLocaleString("sv-SE", {timeZone: "America/Monterrey"}).slice(0,10)
        this.end = end.date || new Date().toLocaleString("sv-SE", {timeZone: "America/Monterrey"}).slice(0,16)
        this.getActivities()
      },
      mapCalendar(item){
        return item.map(id=>{
          return{
            id: id.id,
            start: new Date(id.date),
            end: new Date(id.date),
            name: id.title || ('Anuncio ' + id.id),
            activity_type: id.activity_type?.name,
            description: id.description,
            user: id.user?.name + ' ' + (id.user?.last || ''),
            color: id.activity_type?.color || 'black',
            editedItem:this.mapEditedItem([id])
          }
        })
      },
      mapEditedItem(item){
        var perro = item.map(id=>{
          return{
            id:id.id,
            title:id.title,
            activity_type_id:id.activity_type?.id,
            only_date:id.only_date,
            only_time:id.only_time,
            description:id.description,
            user_id:id.user?.id,
            influencerIds:id.influencers.map(id=>id.id),
          }
        })[0]
        return perro
      },
      getActivities: function() {
        var link = process.env.VUE_APP_BACKEND_ROUTE + "api/v1/calendar_activities?filter[date_between]=" + this.start + ',' + this.end
        if(JSON.parse(localStorage.getItem('filtersActivities'))!=null){
          link = link + JSON.parse(localStorage.getItem('filtersActivities'))
        }
        axios.get(link).then(response => {
          this.events = this.mapCalendar(response.data.data)
        }).catch(error => {
            this.events = []
        })
      },
      openFilter(){
        if(this.filters == false){
          this.$emit("closeDrawer", false);
          this.filters = true
        }else{
          this.$emit("closeDrawer", true);
          this.filters = false
        }
      },
      deleteItem (item) {
        this.deleteId = item.id
        this.sheet = true
      },
      editItem(item){
        this.calendar = item
        this.editDialog = true
      },
      formatAMPM(date) {
        var hours = new Date(date).getHours();
        var minutes = new Date(date).getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
      },
      fecha(date){
        var meses = new Array ("Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre");
        var diasSemana = new Array("Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado");
        return diasSemana[new Date(date).getDay()] + ", " + new Date(date).getDate() + " de " + meses[new Date(date).getMonth()] + " de " + new Date(date).getFullYear()
      },
      closeDialogEditCalendar: function(params) {
        this.editDialog = false;
        this.getActivities()
      },
      closeCreateDialogCalendar: function(params) {
        this.createDialog = false;
        this.getActivities()
      },
      permissions(permission){
        if(this.currentUser.id==1){
          return true
        }else if(this.currentUser.permissions!=undefined){
          if(this.currentUser.permissions.includes(permission)){
            return true
          }else{
            return false
          }
        }else{
          return false
        }
      },
      deleteCalendar(){
        axios.delete(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/activities/"+this.deleteId).then(response => {
            this.deleteId = ''
            this.sheet = false
            this.getActivities()
        }).catch(error => {
            this.snackbar = {
                message: error.response.data.message,
                color: 'error',
                show: true
            }
        });
      },
      htmlContent(html){
        return html
        var content = html
        content = content.replace(/<iframe[^>]*src="([^"]+)"[^>]*><\/iframe>/g, function(match, src) {
          return '<video width="100%" height="auto" style="margin:30px 0px;" controls autoplay="false"><source src="' + src + '" type="video/mp4"></video>';
        });
        for(var i=0; i<100; i++){
          content = content.replace('&gt;', '>').replace('&lt;', '<').replace('&amp;amp', '&amp').replace('&amp;mdash', '&mdash')
        }
        return '<div class="content-style">' + content + '</div><style> .content-style div :first-child { font-size: 14px; } .content-style h4 { font-size: 18px; text-align: justify; } .content-style { word-wrap: break-word; display: flex; justify-content: center; flex-wrap: wrap; } </style>';
      },
    },
    computed:{
      currentUser:{
        get(){
          return this.$store.state.currentUser.user;
        }
      },
    },
    created(){
            this.$store.dispatch('activity/getActivities') 
        },
  }
</script>